import { ICONES, Icone, hora } from "../visual.jsx";
import { autorEmPalavras } from "../marcos.js";

/**
 * O que o escritório FEZ, dentro da conversa.
 *
 * O segundo fio da mesma linha do tempo: a bolha é o que foi dito, o marco é o
 * que aconteceu. Contrato enviado, documento assinado, documento aprovado, peça
 * na esteira, caso aberto no Astrea, processo protocolado — tudo isso estava em
 * `events`, numa trilha que ninguém abre, e a conversa ficava em silêncio
 * enquanto o caso andava. Era o defeito que a auditoria de 22/08 filmou.
 *
 * Desenho de PROPÓSITO diferente da bolha: linha central, fio vertical, fundo
 * de papel e um selo de cor por espécie. Ninguém pode confundir uma coisa que o
 * sistema fez com uma coisa que o cliente disse — a conversa tem valor
 * probatório, e misturar as duas é criar prova que não existe.
 *
 * Interativo onde há para onde ir: o marco da peça abre a petição, o do
 * processo copia o número. O resto é leitura.
 */

/* A cor diz a espécie, e sai toda de token com opacidade (`bg-verde/10`): sem
   isso o cartão traria seis hexadecimais novos para dentro de um componente, que
   é exatamente o que a paleta de `index.css` desfez. Verde é o que fechou,
   terracota é movimento do funil, âmbar é o que espera gente, roxo é peça e
   reunião, azul é sistema de terceiro. */
const PELE = {
  verde: "bg-verde/10 border-verde/30 text-verde-fundo",
  terra: "bg-terra/[.08] border-terra/25 text-terra-escura",
  ambar: "bg-ambar/[.11] border-ambar/30 text-ambar-escuro",
  roxo: "bg-roxo/10 border-roxo/25 text-roxo",
  azul: "bg-azul/[.09] border-azul/25 text-azul",
  cinza: "bg-foreground/4 border-border text-tinta-suave",
};

const ICONE = {
  contrato: ICONES.files,
  assinatura: ICONES.ok ?? ICONES.files,
  ok: ICONES.ok ?? ICONES.files,
  anexo: ICONES.anexo ?? ICONES.files,
  risco: ICONES.risco,
  etapa: ICONES.fluxos,
  peca: ICONES.peticao ?? ICONES.files,
  protocolo: ICONES.ok ?? ICONES.files,
  astrea: ICONES.astrea ?? ICONES.fluxos,
  reuniao: ICONES.calls,
};

export default function MarcoDoCaso({ marco, quando, autor, aoAbrirPeca }) {
  const pele = PELE[marco.cor] ?? PELE.cinza;
  const clicavel = marco.acao === "peca" && aoAbrirPeca;

  return (
    <div className="flex justify-center px-3 py-1.5">
      <div
        /* `role="listitem"` não: a conversa é `role="log"` e o marco é conteúdo
           dela. O que ele precisa é ser LIDO na ordem, e para isso basta estar
           no fluxo com texto de verdade. */
        className={`flex max-w-[min(560px,92%)] items-start gap-2.5 rounded-cartao border px-[13px] py-[9px] text-left ${pele} ${
          clicavel ? "lin cursor-pointer" : ""
        }`}
        onClick={clicavel ? aoAbrirPeca : undefined}
        role={clicavel ? "button" : undefined}
        tabIndex={clicavel ? 0 : undefined}
        onKeyDown={clicavel ? (e) => (e.key === "Enter" || e.key === " ") && aoAbrirPeca() : undefined}
        data-dica={clicavel ? "Abrir a peça" : undefined}
      >
        <span className="mt-px flex-none">
          <Icone de={ICONE[marco.icone] ?? ICONES.fluxos} tamanho={16} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-corpo leading-[1.35] font-bold">{marco.titulo}</span>
          {marco.detalhe ? (
            <span className="mt-[3px] block text-apoio leading-[1.45] text-tinta-media">{marco.detalhe}</span>
          ) : null}
          <span className="mt-[3px] block font-mono text-selo text-tinta-suave">
            {hora(quando)}
            {` · ${autorEmPalavras(autor)}`}
          </span>
        </span>
      </div>
    </div>
  );
}
